import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Label,
  Alert,
} from "reactstrap";
import Select from "react-select";
import Dropzone from "react-dropzone";
import { useSelector } from "react-redux";
// Redux
import { withRouter, Link } from "react-router-dom";
// availity-reactstrap-validation
import {
  AvForm,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
  AvGroup,
  AvInput,
} from "availity-reactstrap-validation";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
//Constants
import { API_WEB_URLS } from "../../constants/constAPI";
//Store
import { compose } from "recompose";
import { container } from "../../store/Containers/cntCommon";

import { Fn_DisplayData, Fn_AddEditData, Fn_FillListData, Fn_ChangeStateValue } from "../../store/functions";
import { API_HELPER } from "helpers/ApiHelper";

class pageAddEdit_FundRequestN extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: 0,
      formData: {},
      Amount: props.Amount || 0,
      F_LedgerGroupMaster : 0,
      QRImage : '',
      isloading : false,
      AccountNo : '',
      AccountHolderName : '',
      IFSC : '',
      UPIId  : '',
      LedgerData : {
        F_LedgerMasterCr : 0,
        F_LedgerMasterDr : 0
      }
    };
    this.obj = this;
    this.formTitle = "Fund Request";
    this.breadCrumbTitle = "Masters";
    this.breadCrumbItem = "Add " + this.formTitle;
    //this.API_URL = API_WEB_URLS.MASTER + "/0/token/LedgerMaster";
    this.API_URL_SAVE =  "InsertFundRequest/0/token";
    this.pushFormName = "/fundrequestreport";

    //Event Binding
    this.btnSave_onClick = this.btnSave_onClick.bind(this);
    this.btnCancel_onClick = this.btnCancel_onClick.bind(this);
    this.getdetails  = this.getdetails.bind(this);
  }


  getdetails(event) {
    if (event.target.value > 0) {
      const foundItem = (this.state.bank || []).find(item => item.Id == event.target.value);
      if (foundItem) {
        this.setState({
          AccountNo: foundItem.AccountNo || '',
          AccountHolderName: foundItem.AccountHolderName || '',
          IFSC: foundItem.IFSC || '',
          UPIId: foundItem.UPIId || '',
          QRImage: foundItem.QRImage || ''
        });
      }
    } else {
      this.setState({
        AccountNo: '',
        AccountHolderName: '',
        IFSC: '',
        UPIId: '',
        QRImage: ''
      });
    }
  }

  componentDidMount() {
    fetch( API_WEB_URLS.BASE+ API_WEB_URLS.MASTER + "/0/token/LedgerBank/F_LedgerGroupMaster/12")  // Replace with your API endpoint
    .then(response => response.json())
    .then(json => this.setState({bank: json.data.dataList }))
    .catch(error => console.error("Error fetching data:", error));

    fetch( API_WEB_URLS.BASE+ API_WEB_URLS.MASTER + "/0/token/PaymentMode/Id/0")  // Replace with your API endpoint
    .then(response => response.json())
    .then(json => this.setState({paymentmode: json.data.dataList }))
    .catch(error => console.error("Error fetching data:", error));

    
    Fn_FillListData(
      this.obj,
      "LedgerR",
      API_WEB_URLS.MASTER + "/0/token/LedgerForFundRequestR/Id/0"
    );

    // Load Dr ledger list (RetailerId list) and auto-select the only/first option
    fetch(API_WEB_URLS.BASE + API_WEB_URLS.MASTER + "/0/token/LedgerForFundRequestD/Id/0")
      .then(response => response.json())
      .then(json => {
        const list = (json.data && json.data.dataList) || [];
        this.setState({ LedgerD: list });
        if (list.length > 0) {
          this.setState(prevState => ({
            LedgerData: {
              ...prevState.LedgerData,
              F_LedgerMasterDr: list[0].Id  // RSevaUserId (e.g. 213)
            }
          }));
        }
      })
      .catch(error => console.error("Error fetching LedgerD:", error));

    this.setState({ id: 0 });
  }

  // Handle prop updates
  componentDidUpdate(prevProps) {
    if (prevProps.Amount !== this.props.Amount) {
      this.setState(prevState => ({
        formData: {
          ...prevState.formData,
          Amount: this.props.Amount || 0
        },
        Amount: this.props.Amount || 0
      }));
    }
  }

  btnSave_onClick  =  async(event, formData) => {
    const userId = this.state.LedgerData.F_LedgerMasterDr;
    const crLedger = this.state.LedgerData.F_LedgerMasterCr;
    const amount = this.state.Amount || formData.Amount || 0;

    if (!formData.BankId || Number(formData.BankId) <= 0) {
      alert('Please select a Bank.');
      return;
    }
    if (!formData.ModeId || Number(formData.ModeId) <= 0) {
      alert('Please select Payment Mode.');
      return;
    }
    if (!formData.TransactionCode || String(formData.TransactionCode).trim() === '') {
      alert('Please enter TXN / Cheque No.');
      return;
    }
    if (!userId || userId === 0) {
      alert('Please select the Retailer (Dr) ledger before submitting.');
      return;
    }
    if (!amount || Number(amount) <= 0) {
      alert('Please enter a valid Amount.');
      return;
    }

    this.setState({isloading : true});

    try {
      const obj = JSON.parse(sessionStorage.getItem("authUser"));
      let vformData = new FormData();
      //Information
      vformData.append("F_BankMaster", formData.BankId || 0);
      vformData.append("PaymentMode", formData.ModeId || 0);
      vformData.append("SenderAccountNo", 0);
      vformData.append("TransactionCode", formData.TransactionCode || "");
      vformData.append("Amount", amount);
      vformData.append("Narration", formData.Remarks || "");
      vformData.append("UserId", userId);
      vformData.append("F_LedgerCr", crLedger || 0);
      vformData.append("F_LedgerDr", userId);
     
      let userToken2 = await API_HELPER.apiPOST_Multipart(
        API_WEB_URLS.BASE + "InsertFundRequest/0/token",
        vformData
      );
     
      alert('Fund Request submitted successfully!');

      this.setState({
        isloading: false,
        AccountNo: '',
        AccountHolderName: '',
        IFSC: '',
        UPIId: '',
        QRImage: ''
      });
    } catch (error) {
      console.error("Error inserting fund request:", error);
      alert('Error: ' + (error.message || 'Could not submit fund request. Check connection.'));
      this.setState({ isloading: false });
    }
  }

  btnCancel_onClick = event => {
    event.preventDefault();
    //this.props.history.goBack();
    this.props.history.push(this.pushFormName);
  };
  render() {
    const mapLedgerToSelectOptions = (ledger) =>
      (ledger || []).map(item => ({
        value: item.Id,
        label: item.Name,
      }));
    const ledgerOptionsR = mapLedgerToSelectOptions(this.state.LedgerR);
    const ledgerOptionsD = mapLedgerToSelectOptions(this.state.LedgerD);

    const {  F_LedgerMasterCr, F_LedgerMasterDr } = this.state.LedgerData;
    const defaultCrAOptionR = ledgerOptionsR.find(option => option.value === F_LedgerMasterCr) || null;
    const defaultDrAOptionD = ledgerOptionsD.find(option => option.value === F_LedgerMasterDr) || null;

    return (
      
      
       
        
            <Row>
             
                <Card>
                  <CardBody>
                    <CardTitle></CardTitle>
                    
                    <AvForm
                      ref={c => (this.form = c)}
                      className="needs-validation"
                      onValidSubmit={this.btnSave_onClick}
                    >

<Row>
                               
                                 
                                    <Row>

                                        <Col >
                                          <label htmlFor="firstName" className="col-form-label"> Select Bank</label>
                                        </Col>


                                      
                                    <Col >
                                        <AvField  name="BankId" label="" value={this.state.formData.BankId === null ? '-1'   : this.state.formData.BankId} onChange={this.getdetails}   type="select" className="form-select" >
                                            <option value={0} defaultValue label={"Select"} />
                                            {this.state.bank
                                              ? this.state.bank.map(
                                                  (option, key) => (
                                                    <option key={option.Id} value={option.Id} label={option.Name} />
                                                  )
                                                )
                                              : null}
                                          </AvField> 
                                        </Col>
                                        </Row>
                                        <Row>

                                        <Col >
                                          <label htmlFor="firstName" className="col-form-label"> Select Mode</label>
                                        </Col>
                                    <Col >
                                      
                                        <AvField  name="ModeId" label="" value={this.state.formData.ModeId === null ? '-1'   : this.state.formData.ModeId}   type="select" className="form-select" >
                                        <option value={0} defaultValue label={"Select"} />
                                            {this.state.paymentmode
                                              ? this.state.paymentmode.map(
                                                  (option, key) => (
                                                    <option key={option.Id} value={option.Id} label={option.Name} />
                                                  )
                                                )
                                              : null}
                                          </AvField> 
                                        </Col>

</Row>
<Row>

                                        <Col >
                                          <label htmlFor="firstName" className="col-form-label">Account Holder</label>
                                        </Col>
                                 
                                        <Col >
                                        <AvField name="AccountHolderName" label="" value={this.state.AccountHolderName } placeholder="AccountHolderName" disabled  type="text"  className="form-control" />
                                        </Col>
                                       
                                        </Row>
                                        <Row>

                                        <Col >
                                          <label htmlFor="firstName" className="col-form-label">Account No</label>
                                        </Col>
                                 
                                        <Col >
                                        <AvField name="AccountNo" label="" value={this.state.AccountNo } placeholder="AccountNo" disabled type="number"  className="form-control" />
                                        </Col>


                                       
                                       


                                    </Row>

                                    <Row>
                                    <Col >
                                          <label htmlFor="firstName" className="col-form-label">IFSC</label>
                                        </Col>
                                 
                                        <Col >
                                        <AvField name="IFSC" label="" value={this.state.IFSC } placeholder="IFSC" disabled type="text"  className="form-control" />
                                        </Col>

                                    {/* <Col sm="2" className="mb-3">
                                          <label htmlFor="firstName" className="col-form-label">SenderAccountNo</label>
                                        </Col>
                                 
                                        <Col sm="3" className="mb-3">
                                        <AvField name="SenderAccountNo" label="" value={this.state.formData.SenderAccountNo } placeholder="SenderAccountNo"  type="number"  className="form-control" />
                                        </Col> */}

</Row>
<Row>


                          <Col >
                                          <label htmlFor="firstName" className="col-form-label">TXN/Cheque No. </label>
                                        </Col>
                                 
                                        <Col >
                                        <AvField name="TransactionCode" label="" value={this.state.formData.TransactionCode  } placeholder="TransactionCode "  type="text"  className="form-control" />
                                        </Col>

                                      

                                        


                                    </Row>

                                    <Row>



                                        
                                    <Col >
                                          <label htmlFor="firstName" className="col-form-label">Remarks </label>
                                        </Col>
                                 
                                        <Col >
                                        <AvField name="Remarks" label="" value={this.state.formData.Remarks  } placeholder="Remarks "  type="text"  className="form-control" />
                                        </Col>
                                    </Row>
                                    
                                    <Row>


<Col >
  <label htmlFor="firstName" className="col-form-label">Amount </label>
</Col>

<Col >
<AvField name="Amount" disabled label="" value={this.state.Amount} placeholder="Amount "  type="number"  className="form-control" />
</Col>

</Row>

</Row>
                                        <Row>
                                  
                                       


                                        <Col >


                                        {this.state.QRImage && this.state.QRImage !== '' ? <>
                      <Row>
                      <Col sm="6" className="mb-3">
                        <img width={300} height={400} src={(API_WEB_URLS.IMAGEBASE || 'https://pro.rsevakendra.in/') + 'QRImages/' + this.state.QRImage} alt="QR Code"></img>
                        </Col>
                       
                      </Row>
                      </> : null} 

                                          </Col>
                                        </Row>


<Row>

<tr>
<td
          style={{
            width: "500px",
            height: "auto",
            overflowY: "auto",
            whiteSpace: "normal",
            zIndex: "99999",
          }}
        >
    Cr
  </td>

  <td
          style={{
            width: "500px",
            height: "auto",
            overflowY: "auto",
            whiteSpace: "normal",
            zIndex: "99999",
          }}
        >
    Dr
  </td>
</tr>
<tr >
        <td
          style={{
            width: "500px",
            height: "auto",
            overflowY: "auto",
            whiteSpace: "normal",
            zIndex: "99999",
          }}
        >
          <Select
            options={ledgerOptionsR}
            onChange={evnt => 
              this.setState(prevState => ({
                LedgerData: {
                  ...prevState.LedgerData, // Keep the existing state
                  F_LedgerMasterCr: evnt.value // Update only the F_LedgerMasterCr field
                }
              }))
            }
            
            styles={{
              container: (provided) => ({
                ...provided,
                height: "auto", // Ensure container height adjusts automatically
                overflowY: "auto", // Allow vertical scrolling if content overflows
                whiteSpace: "normal", // Allow text to wrap
              }),
              singleValue: (provided) => ({
                ...provided,
                whiteSpace: "normal", // Allow text to wrap within single value container
                overflow: "hidden", // Hide any overflow
                textOverflow: "ellipsis", // Add ellipsis for overflow text
              }),
              menu: (provided) => ({
                ...provided,
                position: "absolute",
                zIndex: 9999,
                top: "100%", // Position below the input field
                maxHeight: "200px", // Adjust as needed for maximum height
                overflowY: "auto", // Allow vertical scrolling in the dropdown
              }),
              menuPortal: (base) => ({
                ...base,
                zIndex: 9999,
              }),
            }}
            value={defaultCrAOptionR}
            menuPortalTarget={document.body}
          />
        </td>

        <td
          style={{
            width: "500px",
            height: "auto",
            overflowY: "auto",
            whiteSpace: "normal",
            zIndex: "99999",
          }}
        >
          <Select
            options={ledgerOptionsD}
            onChange={evnt => 
              this.setState(prevState => ({
                LedgerData: {
                  ...prevState.LedgerData, // Keep the existing state
                  F_LedgerMasterDr: evnt.value // Update only the F_LedgerMasterCr field
                }
              }))
            }
            styles={{
              container: (provided) => ({
                ...provided,
                height: "auto", // Ensure container height adjusts automatically
                overflowY: "auto", // Allow vertical scrolling if content overflows
                whiteSpace: "normal", // Allow text to wrap
              }),
              singleValue: (provided) => ({
                ...provided,
                whiteSpace: "normal", // Allow text to wrap within single value container
                overflow: "hidden", // Hide any overflow
                textOverflow: "ellipsis", // Add ellipsis for overflow text
              }),
              menu: (provided) => ({
                ...provided,
                position: "absolute",
                zIndex: 9999,
                top: "100%", // Position below the input field
                maxHeight: "200px", // Adjust as needed for maximum height
                overflowY: "auto", // Allow vertical scrolling in the dropdown
              }),
              menuPortal: (base) => ({
                ...base,
                zIndex: 9999,
              }),
            }}
            value={defaultDrAOptionD}
            menuPortalTarget={document.body}
          />
        </td>
      </tr>
</Row>
                                        

                      
                      <div className="d-flex flex-wrap gap-2">
                        <Button
                          type="submit"
                          color="primary"
                          className="mr-1 waves-effect waves-light"
                        >
                          Proceed
                        </Button>
                        <Button
                          type="button"
                          color="secondary"
                          className="waves-effect"
                          onClick={this.btnCancel_onClick}
                        >
                          Cancel
                        </Button>
                      </div>
                    </AvForm>
                  </CardBody>
                </Card>

               
             
            </Row>
          
      
    );
  }
}
export default compose(container)(pageAddEdit_FundRequestN);
